import { json } from "react-router-dom";
import * as types from "../constants/constants";

export const loginRequest = () => ({
  type: types.LOGIN_REQUEST,
});

export const loginSuccess = (data) => {
  return {
    type: types.LOGIN_SUCCESS,
    payload: data,
  };
};

export const loginFail = (error) => ({
  type: types.LOGIN_FAIL,
  payload: error,
});

export const loginClear = (data) => {
  window.localStorage.removeItem('Token');
  window.sessionStorage.clear();
  return { type: types.LOGIN_DATA_CLEAR, data };
};

export const signupRequest = () => ({
  type: types.SIGNUP_REQUEST,
});

export const signupSuccess = (data) => {

 
  return {
    type: types.SIGNUP_SUCCESS,
    payload: data,
  };
};

export const signupFail = (error) => ({
  type: types.SIGNUP_FAIL,
  payload: error,
});